// extracted by mini-css-extract-plugin
module.exports = {"menuBx":"MenuDrawer_menuBx__mdrSu","SideDrawer":"MenuDrawer_SideDrawer__3JT3S","open":"MenuDrawer_open__tA6is","close":"MenuDrawer_close__JplMu"};